import { Record } from "immutable";
import Locale from "models/Locale";

const SurveyLocaleRecord = Record({
  id: null,
  surveyId: null,
  localeId: null,
  surveyName: "",
  description: "", // アンケートの説明
  answerDescription: "", // 属性回答方法の説明
  lockVersion: 0,
  // 関連
  locale: new Locale()
});

class SurveyLocale extends SurveyLocaleRecord {}

export default SurveyLocale;



// WEBPACK FOOTER //
// ./src/models/SurveyLocale.js